import CopyToClipboardButton from 'components/CopyToClipboardButton';

type CopyActionProps = {
  label: string;
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right';
};

export const CopyAction = ({
  label,
  tooltipPlacement = 'top',
}: CopyActionProps) => {
  return (
    <CopyToClipboardButton
      size="md"
      copyText={label}
      tooltipProps={{ placement: tooltipPlacement }}
    />
  );
};
